export enum BookType {
  INDEXES = 'Indexes', RECORDED_DOCUMENTS = 'Recorded Documents'
}
